export default __webpack_public_path__ + "static/media/STILLBANNER.c47b61c4.jpg";